<template>
  <main>
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/contact/form">お問い合わせフォーム</router-link></li>
        </ul>
      </div>
    </div>
    <div class="contact">
      <div class="contact__title">
        <div class="container">
          <h2>お問い合わせ</h2>
          <ul class="contact__process step3">
            <li>
              <span>1.入力</span>
            </li>
            <li>
              <span>2.確認</span>
            </li>
            <li class="active">
              <span>3.完了</span>
            </li>
          </ul>
          <p style="text-align: center;">お問い合わせを受け付けました</p>
          <div class="contact__title__button">
            <router-link class="btn" to="/">TOPに戻る</router-link>
          </div>
        </div>
      </div>
    </div>
  </main>

</template>

<script>
import { RouterLink } from 'vue-router';

export default {
  name: 'ContactFormComplete',
  props: ['dataComplete'],
  mounted() {
    if(this.$props.dataComplete === undefined) {
      this.$router.push({ name: "ContactForm"});
    }
  }
}
</script>